export default {
    providers: 'providers',
};
